import { getToken, resetState } from "../utils/index";

export default {
  namespaced: true,
  state: {
    error: null,
    loading: false,
    refresh: false,
    initialLoad: true,
    bankTransferTransactions: {
      data: [],
    },
    bankTransferOverview: {},
  },
  mutations: {
    GET_BANK_TRANSFER_TRANSACTIONS_START: (state) => {
      state.loading = true;
    },
    GET_BANK_TRANSFER_TRANSACTIONS_FAILED: (state, error) => {
      state.loading = false;
      state.refresh = false;
      state.error = error;
    },
    GET_BANK_TRANSFER_TRANSACTIONS_SUCCESS: (
      state,
      bankTransferTransactions
    ) => {
      state.loading = false;
      state.refresh = false;
      state.bankTransferTransactions = bankTransferTransactions;
      console.log(bankTransferTransactions);
    },
    GET_BANK_TRANSFER_OVERVIEW_START: (state) => {
      state.loading = true;
    },
    GET_BANK_TRANSFER_OVERVIEW_FAILED: (state, error) => {
      state.loading = false;
      state.refresh = false;
      state.error = error;
    },
    GET_BANK_TRANSFER_OVERVIEW_SUCCESS: (state, bankTransferOverview) => {
      state.loading = false;
      state.refresh = false;
      state.initialLoad = false;
      state.bankTransferOverview = bankTransferOverview;
      console.log(bankTransferOverview);
    },
    REFRESH: (state) => {
      state.refresh = true;
    },
  },
  actions: {
    async getBankTransferTransactions({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_BANK_TRANSFER_TRANSACTIONS_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/transactions?type=transfer&start=${payload.startDate}&end=${payload.endDate}&show=20`,
          config
        );
        const data = await response.json();
        commit("GET_BANK_TRANSFER_TRANSACTIONS_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_BANK_TRANSFER_TRANSACTIONS_FAILED", err);
      }
    },
    async getBankTransferOverview({ commit }, payload) {
      const config = {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };
      try {
        commit("GET_BANK_TRANSFER_OVERVIEW_START");

        let response = await fetch(
          `${process.env.VUE_APP_BASE_URL}/transactions/overview?type=transfer&start=${payload.startDate}&end=${payload.endDate}`,
          config
        );
        const data = await response.json();
        commit("GET_BANK_TRANSFER_OVERVIEW_SUCCESS", data);
        if (response && response.status >= 400 && response.status < 405) {
          resetState();
          return false;
        }

        if (!response.ok) {
          const error = await response.json();
          await Promise.reject(new Error(error.message));
        }
      } catch (err) {
        commit("GET_BANK_TRANSFER_OVERVIEW_FAILED", err);
      }
    },
    async refresh({ commit }) {
      commit("REFRESH");
    },
  },
};
